<template>
  <div class="TicketDetailsAdmin">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>Ticket</span>
            </h1>
            <div class="page-header-subtitle">Ref# {{ this.$route.params.ref }}</div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <table class="table">
                      <tbody>
                        <tr>
                          <th>Status:</th>
                          <td>
                            <span v-if="ticket.status.slug == 'open'" class="badge badge-danger">{{ ticket.status.name }}</span>
                            <span v-else-if="ticket.status.slug == 'closed'" class="badge badge-success">{{ ticket.status.name }}</span>
                            <span v-else-if="ticket.status.slug == 'escalated'" class="badge badge-warning">{{ ticket.status.name }}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ topCategoryLabel }}:</th>
                          <td>{{ ticket.category.name }}</td>
                        </tr>
                        <tr>
                          <th>{{ subCategoryLabel }}:</th>
                          <td>{{ ticket.subCategory.name }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-md-6">
                    <table class="table">
                      <tbody>
                        <tr>
                          <th>Source:</th>
                          <td>Web</td>
                        </tr>
                        <tr>
                          <th>Priority</th>
                          <td>Normal</td>
                        </tr>
                        <tr>
                          <th>Created Date</th>
                          <td>{{ ticket.createdAt | formatDateTime }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card mb-4">
                <div class="card-body">
                  <ul class="timeline">
                    <li>
                      <i class="fa fa-envelope bg-dark"></i>
                      <div class="timeline-item">
                        <span class="time">
                          <i class="far fa-clock"></i>
                          {{ ticket.createdAt | formatDateTime }}
                        </span>
                        <h3 class="timeline-header">
                          <span class="text-primary">{{ ticket.user.name }}'s</span> message
                        </h3>
                        <div class="timeline-body">
                          <h4>{{ ticket.title }}</h4>
                          <div v-html="ticket.body"></div>
                        </div>
                        <div class="timeline-footer" v-if="ticket.attachments.length > 0">
                          <span>Attachment(s)</span>
                          <br />
                          <div v-for="(attachment, index) in ticket.attachments" :key="attachment.uuid">
                            <a :href="attachment.name" class="text-danger" target="_blank">
                              <i class="fa fa-paperclip"></i>
                              Download attachment {{ index + 1 }}
                            </a>
                            <br />
                          </div>
                        </div>
                      </div>
                    </li>

                    <!-- THREAD  -->
                    <li v-for="thread in ticket.threads" :key="thread.uuid">
                      <i v-if="thread.user.email == ticket.user.email" class="fa fa-share bg-danger"></i>
                      <i v-if="thread.user.email != ticket.user.email" class="fa fa-reply bg-primary"></i>

                      <div class="timeline-item">
                        <span class="time">
                          <i class="far fa-clock"></i>
                          {{ thread.createdAt | formatDateTime }}
                        </span>
                        <h3 class="timeline-header">
                          <span v-if="thread.user.email == ticket.user.email">
                            <span class="text-primary">{{ thread.user.name }}'s</span> response
                          </span>
                          <span v-else-if="thread.user.email != ticket.user.email">
                            <span class="text-primary">{{ thread.user.name }}'s</span> response
                          </span>
                        </h3>
                        <div class="timeline-body">
                          <div v-html="thread.body"></div>
                        </div>
                        <div class="timeline-footer" v-if="thread.attachments.length > 0">
                          <span>Attachment(s):</span>
                          <br />
                          <div v-for="(attachment, index) in thread.attachments" :key="attachment.uuid">
                            <a :href="attachment.name" class="text-danger" target="_blank">
                              <i class="fas fa-paperclip"></i>
                              Download attachment {{ index + 1 }}
                            </a>
                            <br />
                          </div>
                        </div>
                      </div>
                    </li>

                    <!-- REPLY FORM -->
                    <!-- <li>
            <i class="far fa-paper-plane bg-dark"></i>
            <div class="timeline-item">
              <h3 class="timeline-header">Reply</h3>
              <div class="timeline-body">
                <!-- replay form 
                <ReplyForm :ticketRef="ticket.ref" :userEmail="authUser.email" @newThread="newThread"></ReplyForm>
                <!-- replay form 
              </div>
            </div>
                    </li>-->

                    <li>
                      <i class="fa fa-clock bg-dark"></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import ReplyForm from "../../../components/ReplyForm";

export default {
  name: "TicketDetailsAdmin",

  data() {
    return {
      ticket: {
        createdAt: "",
        status: { name: "" },
        category: { name: "" },
        subCategory: { name: "" },
        user: { name: "" },
        attachments: [],
        threads: [],
      },
    };
  },

  watch: {
    "$route.params.ref": function (ref) {
      this.loadTicket(ref);
      window.scrollTo(0, 0);
    },
  },

  mounted() {
    this.loadTicket(this.$route.params.ref);
    window.scrollTo(0, 0);
  },

  methods: {
    loadTicket(ref) {
      let loading = this.$loading.show();
      axios
        .get("/user/ticket/" + ref)
        .then((res) => {
          if (res.data.status == "success") {
            this.ticket = res.data.ticket;
          } else {
            this.$swal("Ooops!", res.data.message, "error");
            this.$router.push({ name: "Home" });
          }
          loading.hide();
        })
        .catch((error) => {});
    },

    newThread(e) {
      this.ticket.threads.push(e);
    },
  },

  computed: {
    topCategoryLabel() {
      return this.$store.state.client.topCategoryLabel;
    },
    subCategoryLabel() {
      return this.$store.state.client.subCategoryLabel;
    },
    authUser() {
      return this.$store.state.authUser;
    },
  },

  components: { ReplyForm },
};
</script>

